<template>
  <div class="animated fadeIn">
    <div v-if="!loading">
      <transition name="fade">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <span data-font="16">Closed Service Ticket Details</span>
            <div class="card-header-actions">
              <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="$router.push('/serviceticket/close')"
              ></eb-button>
            </div>
          </div>

          <div class="mx-3 mt-2">
            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="Number"
                      >Service Number</label
                    ></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        type="text"
                        class="input-default-width"
                        placeholder="Enter the Number"
                        v-model="inputObj.number"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr">Created date</label></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-input
                        type="text"
                        placeholder="created Date"
                        class="input-default-width"
                        v-model="inputObj.createdDate"
                        readonly
                      ></b-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="Customer Name"
                      >Customer Name</label
                    ></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        type="text"
                        class="input-default-width"
                        placeholder="Enter your Name"
                        v-model="inputObj.customerName"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="Status"
                      >Status</label
                    ></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        id="Status"
                        type="text"
                        class="input-default-width"
                        label="label"
                        v-model="inputObj.status"
                        placeholder="Select status type"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="customerEmail"
                      >Customer Email</label
                    >
                  </b-col>
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        type="email"
                        class="input-default-width"
                        placeholder="Enter your Email"
                        v-model="inputObj.customerEmail"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="issueType"
                      >Category</label
                    ></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        id="issueType"
                        type="text"
                        class="input-default-width"
                        v-model="inputObj.issueType"
                        placeholder="Enter issue type"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr">Assign To</label></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        id="_id"
                        class="input-default-width"
                        type="text"
                        v-model="inputObj.assignTo"
                        placeholder="All Seller"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="subject"
                      >Subject</label
                    ></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-textarea
                        id="subject"
                        type="text"
                        placeholder="Enter the Subject."
                        v-model="inputObj.subject"
                        no-resize
                        readonly
                        style="height: 35px; width: 220px"
                      ></b-form-textarea>
                    </div>
                  </b-col>
                </b-row> </b-col
            ></b-row>

            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="customerPhone"
                      >Customer Phone</label
                    ></b-col
                  >
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        type="number"
                        class="input-default-width"
                        placeholder="Enter your Phone Number"
                        v-model="inputObj.customerPhone"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                    <label class="input-label-sr" for="priority"
                      >Priority</label
                    >
                  </b-col>
                  <b-col md="9">
                    <div class="form-group">
                      <b-form-input
                        id="Priority"
                        class="input-default-width"
                        type="text"
                        v-model="inputObj.priority"
                        placeholder="Select priority type"
                        readonly
                      ></b-form-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <label class="mt-3" for="description">Description</label>
            <b-form-textarea
              id="description"
              placeholder="Enter the Description"
              v-model="inputObj.description"
              rows="3"
              max-rows="6"
              readonly
            ></b-form-textarea>
            <div
              v-if="
                inputObj.status == 'CLOSED' && !inputObj.closingReason == ''
              "
            >
              <label class="mt-3" for="closingReason">Closing Reason</label>
              <b-form-textarea
                id="closingReason"
                placeholder="Enter Closing Reason"
                v-model="inputObj.closingReason"
                rows="3"
                max-rows="6"
                readonly
              ></b-form-textarea>
            </div>
            <div
              v-if="
                Array.isArray(inputObj.workNoteHistoryList) &&
                inputObj.workNoteHistoryList.length > 0
              "
            >
              <label class="mt-3" for="workNoteHistory"
                >Work Note History</label
              >

              <div class="mt-2">
                <b-list-group class="list-group">
                  <b-list-group-item
                    class="bs-callout bs-callout-default"
                    v-for="(item, index) in inputObj.workNoteHistoryList"
                    :key="index"
                  >
                    <div>
                      <div class="float-right">
                        <b-row>
                          <b-col>
                            <p class="float-right">
                              {{ item.updatedBy.name }} ,
                              {{ formatDateTime(item.updatedAt) }}
                            </p>
                          </b-col>
                        </b-row>
                      </div>

                      <h4>{{ item.updatedBy.userType }}</h4>
                      <p class="ml-1 mt-n1">{{ item.description }}</p>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
            <div
              v-if="
                Array.isArray(inputObj.noteToInternalCommentsList) &&
                inputObj.noteToInternalCommentsList.length > 0
              "
            >
              <label class="mt-3" for="workNoteHistory"
                >Internal note history</label
              >

              <div class="mt-2">
                <b-list-group class="list-group">
                  <b-list-group-item
                    class="bs-callout bs-callout-default"
                    v-for="(item, index) in inputObj.noteToInternalCommentsList"
                    :key="index"
                  >
                    <div>
                      <div class="float-right">
                        <b-row>
                          <b-col>
                            <p class="float-right">
                              {{ item.updatedBy.name }} ,
                              {{ formatDateTime(item.updatedAt) }}
                            </p>
                          </b-col>
                        </b-row>
                      </div>
                      <div>
                        <h4>{{ item.updatedBy.userType }}</h4>
                        <p align="left" class="ml-1 mt-n1">
                          {{ item.description }}
                        </p>
                      </div>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>
        </b-card>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
export default {
  name: "CustomerClosedTicketView",
  components: {
    ebSelect,
    ebButton,
  },
  data: () => {
    return {
      loading: false,
      inputObj: {
        number: "",
        createdDate: "",
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        issuedTo: "",
        priority: "",
        issueType: "",
        status: "",
        subject: "",
        closingReason: "",
        description: "",
        workNoteHistoryList: [],
        noteToInternalCommentsList: [],
        assignTo: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      getOpenServiceTicket: "serviceticket/GetOpenServiceTicket",
    }),
    getStoreServiceTicketData() {
      let ticketData = this.getOpenServiceTicket.find(
        (ticket) => ticket._id == this.$route.params.id
      );

      this.inputObj.number = ticketData.ticketNo;
      this.inputObj.createdDate = this.formatDateTime(ticketData.createdAt);
      this.inputObj.customerName = ticketData.reportedBy.name
        ? ticketData.reportedBy.name
        : "";
      this.inputObj.status = ticketData.status ? ticketData.status : "";
      this.inputObj.customerEmail = ticketData.reportedBy.email
        ? ticketData.reportedBy.email
        : "";
      this.inputObj.customerPhone = ticketData.reportedBy.phone
        ? ticketData.reportedBy.phone
        : "";
      this.inputObj.assignTo = ticketData.assignTo.name;
      this.inputObj.issueType = ticketData.category.name
        ? ticketData.category.name
        : "";
      this.inputObj.priority = ticketData.priority ? ticketData.priority : "";

      this.inputObj.description = ticketData.description
        ? ticketData.description
        : "";

      this.inputObj.subject = ticketData.subject ? ticketData.subject : "";
      try {
        if (
          Array.isArray(ticketData.worknoteHistory) &&
          ticketData.worknoteHistory.length > 0
        ) {
          this.inputObj.workNoteHistoryList = ticketData.worknoteHistory.sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          );
        } else {
          this.inputObj.workNoteHistoryList = [];
        }
      } catch (err) {
        this.inputObj.workNoteHistoryList = [];
      }

      try {
        if (
          Array.isArray(ticketData.internalComments) &&
          ticketData.internalComments.length > 0
        ) {
          this.inputObj.noteToInternalCommentsList =
            ticketData.internalComments.sort(
              (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
            );
        } else {
          this.inputObj.noteToInternalCommentsList = [];
        }
      } catch (err) {
        this.inputObj.noteToInternalCommentsList = [];
      }

      if (ticketData.closingReason) {
        this.inputObj.closingReason = ticketData.closingReason;
      } else {
        this.inputObj.closingReason = "";
      }
    },
  },

  methods: {
    formatDateTime: function (value) {
      return moment(value).format("DD/MM/YYYY  h:mm A");
    },
    getProperTime: function (value) {
      return moment(value).format("h:mm A");
    },
  },

  async mounted() {
    this.loading = true;
    const payload = {
      id: "",
    };
    if (this.$currentUserData.category === "SELLER") {
      payload.id = this.$currentUserData._id;
    }
    await this.$store.dispatch(
      "serviceticket/openServiceTicketAction",
      payload
    );
    this.loading = false;
    this.getStoreServiceTicketData;
  },
};
</script>

<style>
[data-font="16"] {
  font-size: 16px;
}
.list-group {
  max-height: 300px;
  margin-bottom: 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.bs-callout {
  padding: 14px;
  margin: 2px 0;
  border: 1px solid #eee;
  border-left-width: 5px;
  border-radius: 3px;
  height: 86px;
}
.bs-callout-default {
  border-left-color: #898df5;
}
.bs-callout-success {
  border-left-color: #898df5;
}
h4 {
  color: #898df5;
  font-weight: bold;
}
.input-default-width {
  width: 220px;
}
.input-label-sr {
  margin-top: 15px;
}
</style>
